import { __exports as stream } from "../../../../../../_virtual/stream.js";
var hasRequiredStream;
function requireStream() {
  if (hasRequiredStream) return stream;
  hasRequiredStream = 1;
  (function(exports$1) {
    var __awaiter = stream && stream.__awaiter || function(thisArg, _arguments, P, generator) {
      function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
          resolve(value);
        });
      }
      return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
          try {
            step(generator.next(value));
          } catch (e) {
            reject(e);
          }
        }
        function rejected(value) {
          try {
            step(generator["throw"](value));
          } catch (e) {
            reject(e);
          }
        }
        function step(result) {
          result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
      });
    };
    Object.defineProperty(exports$1, "__esModule", { value: true });
    exports$1.SdkStream = exports$1.DEFAULT_STREAM_ERR_EVENTS = void 0;
    exports$1.DEFAULT_STREAM_ERR_EVENTS = {
      TIMEOUT: { message: "timeout" },
      DATA_UNPARSABLE: {
        message: "stream data parse error"
      },
      KEEP_ALIVE_FAILURE: {
        message: "keep alive fail"
      }
    };
    const DEFAULT_INITIAL_CONN_TIMEOUT = 1e3;
    const MAX_CONN_MS_MIN = 12 * 60 * 1e3;
    const MAX_CONN_MS_MAX = 18 * 60 * 1e3;
    const KEEP_ALIVE_INTERVAL = (15 + 2) * 1e3;
    const KEEP_ALIVE_DATA = " ";
    class SdkStream {
      constructor(deploymentKey, serverUrl, eventSourceFactory, streamConnTimeoutMillis = DEFAULT_INITIAL_CONN_TIMEOUT) {
        this.deploymentKey = deploymentKey;
        this.serverUrl = serverUrl;
        this.eventSourceFactory = eventSourceFactory;
        this.streamConnTimeoutMillis = streamConnTimeoutMillis;
      }
      connect(options) {
        return __awaiter(this, void 0, void 0, function* () {
          if (this.eventSource) {
            return;
          }
          const headers = {
            Authorization: `Api-Key ${this.deploymentKey}`
          };
          if ((options === null || options === void 0 ? void 0 : options.libraryName) && (options === null || options === void 0 ? void 0 : options.libraryVersion)) {
            headers["X-Amp-Exp-Library"] = `${options.libraryName}/${options.libraryVersion}`;
          }
          const es = this.eventSourceFactory(this.serverUrl, {
            headers
          });
          this.eventSource = es;
          es.onerror = (err) => err && this.error(err);
          es.onmessage = (evt) => this.handleNewMsg(evt);
          es.onopen = (evt) => {
            if (!evt || !(evt === null || evt === void 0 ? void 0 : evt.type) || evt.type != "open") {
              return;
            }
            const randomReconnectionTimeout = Math.floor(Math.random() * (MAX_CONN_MS_MAX - MAX_CONN_MS_MIN) + MAX_CONN_MS_MIN);
            if (this.reconnectionTimeout) {
              clearTimeout(this.reconnectionTimeout);
            }
            this.reconnectionTimeout = setTimeout(() => __awaiter(this, void 0, void 0, function* () {
              if (es.readyState == es.OPEN) {
                this.close();
                this.connect();
              }
            }), randomReconnectionTimeout);
            this.setKeepAliveExpiry();
          };
          if (this.initConnTimeout) {
            clearTimeout(this.initConnTimeout);
          }
          this.initConnTimeout = setTimeout(() => {
            es.readyState == es.CONNECTING && // The es is being checked, not this.eventSource. So it won't affect new connections.
            this.error(exports$1.DEFAULT_STREAM_ERR_EVENTS.TIMEOUT);
          }, this.streamConnTimeoutMillis);
        });
      }
      close() {
        if (this.eventSource) {
          this.eventSource.close();
          this.eventSource = void 0;
        }
        if (this.initConnTimeout) {
          clearTimeout(this.initConnTimeout);
          this.initConnTimeout = void 0;
        }
        if (this.reconnectionTimeout) {
          clearTimeout(this.reconnectionTimeout);
          this.reconnectionTimeout = void 0;
        }
        if (this.keepAliveTimeout) {
          clearTimeout(this.keepAliveTimeout);
          this.keepAliveTimeout = void 0;
        }
      }
      error(err) {
        return __awaiter(this, void 0, void 0, function* () {
          this.close();
          if (this.onError) {
            try {
              yield this.onError(err);
            } catch (_a) {
            }
          }
        });
      }
      handleNewMsg(response) {
        return __awaiter(this, void 0, void 0, function* () {
          if (!response.data) {
            return;
          }
          this.setKeepAliveExpiry();
          if (response.data == KEEP_ALIVE_DATA) {
            return;
          }
          if (this.onUpdate) {
            try {
              yield this.onUpdate(response.data);
            } catch (_a) {
            }
          }
        });
      }
      setKeepAliveExpiry() {
        if (this.keepAliveTimeout) {
          clearTimeout(this.keepAliveTimeout);
          this.keepAliveTimeout = void 0;
        }
        if (this.eventSource) {
          this.keepAliveTimeout = setTimeout(() => {
            this.error(exports$1.DEFAULT_STREAM_ERR_EVENTS.KEEP_ALIVE_FAILURE);
          }, KEEP_ALIVE_INTERVAL);
        }
      }
    }
    exports$1.SdkStream = SdkStream;
  })(stream);
  return stream;
}
export {
  requireStream as __require
};
//# sourceMappingURL=stream.js.map
